// extracted by mini-css-extract-plugin
export default {"preference":"sort-preference_preference__OoHap","placeholder":"sort-preference_placeholder__QtS78","indicator":"sort-preference_indicator__n18oX"};